import { ArrowLeftOutlined, WarningFilled } from '@ant-design/icons';
import {
  getGetFrontRichiesteIdQueryKey,
  usePutFrontRichiesteIdStato,
} from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { EnumUpdateStatoRichiestaRequestStato } from '@framework/api-client/api/inquiries-compile/schemas/enumUpdateStatoRichiestaRequestStato.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { ModalDialog } from '@framework/ui/components/modal/ModalDialog.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Button, Flex, message, Space, Typography } from 'antd';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { queryClient } from '../../../core/network/queryClient.ts';

const { Text } = Typography;

export const BannerWrapper = styled.div`
  /* display: grid !important;
  grid-template-columns: 1fr 6fr 1fr; */
  min-height: 30px;
  background-color: ${props => props.theme.colorWarningBg};
  padding: 12px;
`;
export const BannerIcon = styled.span`
  font-size: 24px;
  color: ${props => props.theme.colorTextBase};
`;
const WarningIcon = styled(WarningFilled)`
  color: ${props => props.theme.colorWarning};
`;

interface InPaymentBannerProps {
  submissionId: string;
  isPaymentCancelable?: boolean | null;
}

export function InPaymentBanner(props: InPaymentBannerProps) {
  const { submissionId, isPaymentCancelable } = props;
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = React.useState(false);
  const { mutate: updateSubmissionState, isLoading } =
    usePutFrontRichiesteIdStato({
      mutation: {
        onSuccess: response => {
          setModalOpen(false);
          const submissionQueryKey =
            getGetFrontRichiesteIdQueryKey(submissionId)[0];
          queryClient.invalidateQueries({
            predicate: ({ queryKey }) =>
              (queryKey[0] as string).includes(submissionQueryKey),
          });
        },
        onError: e => {
          message.error(
            getNetworkErrorMessage(
              e,
              `Si è verificato un errore durante la modifica dello stato della richiesta`,
            ),
          );
        },
      },
    });

  const handleConfirm = () => {
    updateSubmissionState({
      id: submissionId,
      data: { stato: EnumUpdateStatoRichiestaRequestStato.BOZZA },
    });
  };

  return (
    <BannerWrapper>
      <FlexRow
        gutter={12}
        left={
          isPaymentCancelable && (
            <Button
              icon={<ArrowLeftOutlined />}
              ghost
              type="primary"
              onClick={() => setModalOpen(true)}
              loading={isLoading}
            >
              {t(
                'submission-payment.in-payment-banner-action',
                'Riporta in bozza',
              )}
            </Button>
          )
        }
      >
        <Flex align="center" justify="center" gap={12}>
          {/* <BannerIcon>
            <CalculatorOutlined aria-label="Informazione" />
          </BannerIcon> */}
          <Text strong>
            {isPaymentCancelable
              ? t(
                  'submission-payment.in-payment-banner-title',
                  `La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche.`,
                )
              : t(
                  'submission-payment.in-payment-banner-title-no-cancel',
                  `La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla.`,
                )}
          </Text>
        </Flex>
      </FlexRow>

      <ModalDialog
        open={modalOpen}
        title={
          <Space>
            <WarningIcon />
            {t(
              'submission-payment.annulla-pagamenti-e-ritorna-in-bozza',
              'Annulla pagamenti e ritorna in bozza',
            )}
          </Space>
        }
        onOk={handleConfirm}
        onCancel={() => setModalOpen(false)}
        width={600}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Trans
            i18nKey="submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza"
            defaults="Riportando la richiesta in bozza, tutti <bold>i bolli pagati verranno invalidati</bold> e sarà necessario effettuare di nuovo il pagamento."
            components={{
              bold: <b />,
            }}
          />
          <span>
            {t(
              'submission-payment.conferma-a-procedere',
              'Si è sicuri di voler procedere?',
            )}
          </span>
        </Space>
      </ModalDialog>
    </BannerWrapper>
  );
}
